import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Save, Loader2, KeyRound } from "lucide-react";

export default function AdminAccount() {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("New password must be at least 8 characters."); return; }
    if (next !== confirm) { toast.error("New password + confirmation do not match."); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password updated.");
      setCur(""); setNext(""); setConfirm("");
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  const cls = "w-full border-2 border-[var(--rts-blue-pale)] focus:border-[var(--rts-blue)] rounded-xl px-3 py-2.5 outline-none min-h-[44px]";

  return (
    <div data-testid="admin-account">
      <div className="mb-6">
        <h1 className="font-display text-3xl text-[var(--rts-ink)]">My Account</h1>
        <p className="text-sm text-[var(--rts-muted)] mt-1">Signed in as <strong>{user?.email}</strong></p>
      </div>

      <form onSubmit={submit} className="bg-white rounded-2xl border border-[var(--rts-blue-pale)] p-6 max-w-md space-y-4" data-testid="change-password-form">
        <div className="flex items-center gap-2 mb-2">
          <KeyRound className="w-5 h-5 text-[var(--rts-blue-deep)]" />
          <h2 className="font-display text-lg text-[var(--rts-ink)]">Change password</h2>
        </div>
        <label className="block">
          <span className="block text-sm font-semibold text-[var(--rts-ink)] mb-1">Current password</span>
          <input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required className={cls} data-testid="pw-current" />
        </label>
        <label className="block">
          <span className="block text-sm font-semibold text-[var(--rts-ink)] mb-1">New password <span className="font-normal text-[var(--rts-muted)]">(min 8 chars)</span></span>
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} className={cls} data-testid="pw-new" />
        </label>
        <label className="block">
          <span className="block text-sm font-semibold text-[var(--rts-ink)] mb-1">Confirm new password</span>
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} className={cls} data-testid="pw-confirm" />
        </label>
        <button
          type="submit"
          disabled={saving || !cur || !next || !confirm}
          data-testid="pw-save-btn"
          className="w-full inline-flex items-center justify-center gap-2 bg-[var(--rts-blue-deep)] hover:bg-[var(--rts-blue)] text-white font-bold px-6 py-2.5 rounded-full disabled:opacity-60 min-h-[44px]"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          Update password
        </button>
      </form>
    </div>
  );
}
